import { jsx as _jsx } from "react/jsx-runtime";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { createTRPCClient, httpBatchLink, httpSubscriptionLink, retryLink, splitLink } from "@trpc/client";
import { useMemo } from "react";
import { TRPCProvider } from "../trpc.js";
import { get } from "es-toolkit/compat";
const nonRecoverableErrorCodes = [
    401,
    400,
    403,
    404,
    405,
    410,
];
export const QueryProvider = ({ children }) => {
    const queryClient = useMemo(() => {
        return new QueryClient({
            defaultOptions: {
                queries: {
                    retry: 10,
                },
            },
        });
    }, []);
    const trpcClient = useMemo(() => createTRPCClient({
        links: [
            retryLink({
                retry: ({ op, error }) => {
                    if (op.type === "subscription") {
                        window.logger.info({ error }, "Retrying subscription connection");
                        return true;
                    }
                    const status = get(error, "data.httpStatus", 0);
                    if (nonRecoverableErrorCodes.includes(status)) {
                        window.logger.info({ error }, "Not retrying non-recoverable error");
                        return false;
                    }
                    else {
                        window.logger.info({ error }, "Retrying request due to error");
                        return true;
                    }
                },
                retryDelayMs: attempts => Math.min(1000 * attempts, 30_000),
            }),
            splitLink({
                condition: op => op.type === "subscription",
                true: httpSubscriptionLink({
                    url: "/api/trpc",
                }),
                false: httpBatchLink({
                    url: "/api/trpc",
                    maxURLLength: 1024,
                }),
            }),
        ],
    }), []);
    return (_jsx(QueryClientProvider, { client: queryClient, children: _jsx(TRPCProvider, { trpcClient: trpcClient, queryClient: queryClient, children: children }) }));
};
